import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
import { ExternalLookupIdentifier, LookupIdentifier, Reference } from '../Shared/SharedModels';
import { Nullable } from '../Shared/Types';
import { MedicareCardVerificationErrorSource, MedicareCardVerificationRequestStatus } from './Models';

export const verifyPatientMedicareCard = (cardVerification: RegisterDeviceContracts.Request.MedicareCardVerification) =>
    getExecutor(getConfig().apiEndpoints.servicesAustralia).post<
        RegisterDeviceContracts.Request.MedicareCardVerification,
        RegisterDeviceContracts.Response.MedicareCardVerificationResult
    >(`api/v1/patients/medicare-card/verify`, cardVerification);

export namespace RegisterDeviceContracts {
    export namespace Request {
        export interface MedicareCardVerification {
            authoringSystem: string;
            authoringSystemForeignKey: string;
            minorId: string;
            patient: PatientSnapshot;
            device: Nullable<ExternalLookupIdentifier>;
        }

        interface PatientSnapshot {
            authoringSystem: string;
            authoringSystemForeignKey: string;
            dateOfBirth: string;
            familyName: string;
            givenName: string;
            sex: Nullable<Reference>;
            medicareCardNumber: string;
            medicareCardReferenceNumber: string;
        }
    }

    export namespace Response {
        export interface MedicareCardVerificationResult {
            authoringSystem: string;
            authoringSystemForeignKey: string;
            deviceExpiresOn: string;
            status: MedicareCardVerificationRequestStatus;
            assessedDetails: MedicareCardVerificationAssessedDetails;
            newCardDetails: MedicareCardVerificationNewCardDetails;
            patient: PatientSnapshot;
            errors: MedicareCardVerificationError[];
        }

        interface PatientSnapshot {
            dateOfBirth: string;
            familyName: string;
            givenName: string;
            sex: Reference;
            medicareCardNumber: string;
            medicareCardReferenceNumber: string;
        }

        interface MedicareCardVerificationAssessedDetails {
            code: string;
            message: string;
        }

        interface MedicareCardVerificationNewCardDetails {
            reference: string;
            cardNumber: string;
            givenName: string;
        }

        interface MedicareCardVerificationError {
            source: MedicareCardVerificationErrorSource;
            code: string;
            message: string;
        }
    }
}
